import {Stage, WizardStepEnum} from './types';
import {
    DefineFiscalYearStep,
    JournalEntriesCheckStep,
    NumerationTemplatesStep,
    FinishedStep as S0FinishedStep
} from './Steps/ReachingTheYearEndStage';
import {
    CloseCashiersStep,
    CompareCashierBalancesStep,
    RunCashierBalanceReportStep,
    RunEndOfYearReportsStep,
    FinishedStep as S1FinishedStep
} from './Steps/LastDayOfTheYearStage';
import {
    TransferOpenBalancesStep,
    FinishedStep as S2FinishedStep
} from './Steps/StartOfTheYearStage';

export const localStorageStepKey = 'EOY_step';
export const successStepLogId = '100';

export const stageStepsMapping: Stage[] = [
    {
        name: 'stage0_title',
        steps: [
            {
                name: 'stage0_step0_name',
                description: 'stage0_step0_description',
                next_button: 'stage0_step0_next_button',
                type: WizardStepEnum.Welcome
            },
            {
                name: 'stage0_step1_title',
                nameShort: 'stage0_step1_name',
                type: WizardStepEnum.Common,
                component: DefineFiscalYearStep,
                logId: '20'
            },
            {
                name: 'stage0_step2_title',
                nameShort: 'stage0_step2_name',
                type: WizardStepEnum.Common,
                component: NumerationTemplatesStep,
                logId: '30'
            },
            {
                name: 'stage0_step3_title',
                nameShort: 'stage0_step3_name',
                type: WizardStepEnum.Common,
                component: JournalEntriesCheckStep,
                logId: '40'
            },
            {
                name: '',
                hideStep: true,
                type: WizardStepEnum.Finished,
                component: S0FinishedStep
            }
        ]
    },
    {
        name: 'stage1_title',
        steps: [
            {
                name: 'stage0_step0_name',
                description: 'stage1_step0_description',
                next_button: 'next_button_label',
                type: WizardStepEnum.Welcome
            },
            {
                name: 'stage1_step1_title',
                nameShort: 'stage1_step1_name',
                type: WizardStepEnum.Common,
                component: CompareCashierBalancesStep,
                logId: '50'
            },
            {
                name: 'stage1_step2_name',
                nameShort: 'stage1_step2_name',
                type: WizardStepEnum.Common,
                component: RunCashierBalanceReportStep,
                logId: '60'
            },
            {
                name: 'stage1_step3_name',
                nameShort: 'stage1_step3_name',
                type: WizardStepEnum.Common,
                component: CloseCashiersStep,
                logId: '70'
            },
            {
                name: 'stage1_step4_title',
                nameShort: 'stage1_step4_name',
                type: WizardStepEnum.Common,
                component: RunEndOfYearReportsStep,
                logId: '80'
            },
            {
                name: '',
                hideStep: true,
                type: WizardStepEnum.Finished,
                component: S1FinishedStep
            }
        ]
    },
    {
        name: 'stage2_title',
        steps: [
            {
                name: 'stage0_step0_name',
                next_button: 'next_button_label',
                description: 'stage1_step0_description',
                type: WizardStepEnum.Welcome
            },
            {
                name: 'stage2_step1_name',
                nameShort: 'stage2_step1_name',
                type: WizardStepEnum.Common,
                component: TransferOpenBalancesStep,
                logId: '90'
            },
            {
                name: '',
                hideStep: true,
                type: WizardStepEnum.Finished,
                component: S2FinishedStep,
                logId: successStepLogId
            }
        ]
    }
];

export const logIdToStageStepIndex = (logId: string) => {
    let result = null;
    if (logId) {
        stageStepsMapping.forEach((stage, stageIndex) => {
            stage.steps.forEach((step, stepIndex) => {
                if (step.logId === logId) {
                    result = {stageIndex, stepIndex};
                }
            });
        });
    } else {
        const lastStageInd = stageStepsMapping.length - 1;
        const lastStage = stageStepsMapping[lastStageInd];
        const lastStepInd = lastStage.steps.length - 1;
        result = {stageIndex: stageStepsMapping.length - 1, viewStepIndex: lastStepInd};
    }
    return result;
};

export const reportIdByReportName = {
    CHKFNCTRANS: '10',
    CASHBAL: '11',
    DOC_DEBIT_S: '12',
    DELAYCHECK2: '13',
    LOANS_BY_YEARS: '14'
};
